export enum ConversionStep {
  INITIALIZING = 'INITIALIZING',
  ANALYZING_STAGES = 'ANALYZING_STAGES',
  GENERATING_TEMPLATES = 'GENERATING_TEMPLATES',
  GENERATING_PIPELINE = 'GENERATING_PIPELINE',
  SAVING_ARTIFACTS = 'SAVING_ARTIFACTS',
  COMPLETED = 'COMPLETED',
  RETRIEVING_FILES = 'RETRIEVING_FILES',
  REFINING_WITH_FEEDBACK = 'REFINING_WITH_FEEDBACK',
  SAVING_REFINED = 'SAVING_REFINED'
}

export interface ConversionStepDefinition {
  key: ConversionStep;
  displayName: string;
  defaultIcon: string;
}

export interface ConversionStepState extends ConversionStepDefinition {
  status: 'Pending' | 'In Progress' | 'Complete' | 'Failed';
  icon: string;
}

export const CONVERSION_STEP_DEFINITIONS: Record<ConversionStep, ConversionStepDefinition> = {
  [ConversionStep.INITIALIZING]: {
    key: ConversionStep.INITIALIZING,
    displayName: 'Initializing',
    defaultIcon: 'pending'
  },
  [ConversionStep.ANALYZING_STAGES]: {
    key: ConversionStep.ANALYZING_STAGES,
    displayName: 'Analyzing Stages and Dependencies',
    defaultIcon: 'pending'
  },
  [ConversionStep.GENERATING_TEMPLATES]: {
    key: ConversionStep.GENERATING_TEMPLATES,
    displayName: 'Generating Stage Templates',
    defaultIcon: 'pending'
  },
  [ConversionStep.GENERATING_PIPELINE]: {
    key: ConversionStep.GENERATING_PIPELINE,
    displayName: 'Generating Main Pipeline',
    defaultIcon: 'pending'
  },
  [ConversionStep.SAVING_ARTIFACTS]: {
    key: ConversionStep.SAVING_ARTIFACTS,
    displayName: 'Saving Artifacts',
    defaultIcon: 'pending'
  },
  [ConversionStep.COMPLETED]: {
    key: ConversionStep.COMPLETED,
    displayName: 'Completed',
    defaultIcon: 'pending'
  },
  [ConversionStep.RETRIEVING_FILES]: {
    key: ConversionStep.RETRIEVING_FILES,
    displayName: 'Retrieving file content',
    defaultIcon: 'pending'
  },
  [ConversionStep.REFINING_WITH_FEEDBACK]: {
    key: ConversionStep.REFINING_WITH_FEEDBACK,
    displayName: 'Refining YAML with user feedback',
    defaultIcon: 'pending'
  },
  [ConversionStep.SAVING_REFINED]: {
    key: ConversionStep.SAVING_REFINED,
    displayName: 'Saving refined artifacts',
    defaultIcon: 'pending'
  }
};

export const INITIAL_CONVERSION_FLOW: ConversionStep[] = [
  ConversionStep.INITIALIZING,
  ConversionStep.ANALYZING_STAGES,
  ConversionStep.GENERATING_TEMPLATES,
  ConversionStep.GENERATING_PIPELINE,
  ConversionStep.SAVING_ARTIFACTS,
  ConversionStep.COMPLETED,
  ConversionStep.RETRIEVING_FILES
];

export const REFINEMENT_CONVERSION_FLOW: ConversionStep[] = [
  ConversionStep.INITIALIZING,
  ConversionStep.REFINING_WITH_FEEDBACK,
  ConversionStep.SAVING_REFINED,
  ConversionStep.COMPLETED,
  ConversionStep.RETRIEVING_FILES
];

export const SERVER_STATUS_MAP: Record<string, ConversionStep> = {
  'Initializing': ConversionStep.INITIALIZING,
  'Analyzing Stages and Dependencies': ConversionStep.ANALYZING_STAGES,
  'Generating Stage Templates': ConversionStep.GENERATING_TEMPLATES,
  'Generating Main Pipeline': ConversionStep.GENERATING_PIPELINE,
  'Saving Artifacts': ConversionStep.SAVING_ARTIFACTS,
  'Completed': ConversionStep.COMPLETED,
  'Retrieving file content': ConversionStep.RETRIEVING_FILES,
  'Refining YML with user feedback': ConversionStep.REFINING_WITH_FEEDBACK,
  'Saving refined artifacts': ConversionStep.SAVING_REFINED
};
